module.exports = __webpack_public_path__ + "img/Nieuwbouw.6c3de14c.svg";